var _defs, _rect, _rect2, _polygon, _g, _polygon2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPas8Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Object",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1122 1122",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        stroke-width: 11.6px;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        fill: #323c88;\r\n        stroke: #323a89;\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-width: 17.4px;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: #30378b;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 324.72,
    y: 283.47,
    width: 313.2,
    height: 67.32
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 324.72,
    y: 440.07,
    width: 210.94,
    height: 67.32
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "895.53 568.34 866.79 568.34 866.79 249.54 676.37 52.88 230.68 52.88 230.68 568.34 201.94 568.34 201.94 24.14 688.54 24.14 895.53 237.91 895.53 568.34"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m567.63,1107.91c-21.84,1.74-39.9-19.84-54.37-33.09,0,0-204.18-161.16-204.18-161.16-29.31-.34-97.43,22.47-119.05-7.06l21.27-19.32c8.04,14.37,87.94-4.19,100.56-2.81,18.35-21.21,46.89-70.8,79.93-42.7,10.68,10.37,38.36,26.39,39.44,43.09,17.78,3.82,58.6,35.47,57.37,55.77,17.44,8.75,50.2,31.18,52.45,52.34,11.69,1.25,33.11,23.64,42.3,30.21,15.82,17.87,16.92,23.98-3.39,53.52,48.13-41.72,175.58-164.05,221.75-204.44l-190.7-178.95c-4.55-3.3-7.66-3-11.48.99-25.73,29.54-58.38,82.98-104.18,76.39-42.28,1.23-57.91-49.03-32.91-71.7,13.71-18.14,72.21-87.77,87.55-106.72-3.33-2.5-7.37-3.86-11.55-3.86H237.94v-28.74c18.17,4.28,328.69-11.4,331.92,11.74,7.82-21.71,247.32-7.65,266.07-11.63l.06,28.74-236.83.46c-4.22.34-8.25,2.09-11.4,4.94-22.94,22.55-83.86,100.23-103.77,124.06-22.77,33.55,41.53,27.8,52.88,6.32,21.44-22.44,56.3-87.72,93.8-51.96,0,0,199.53,187.23,199.53,187.23,10.83,2.16,32.25,13.88,41.75,2.47l19.61,21c-17.45,17.93-43.96,13.43-65.01,5.42-45.18,40.52-176.11,162.81-222.36,206.03-9.71,9.34-23.3,13.22-36.56,13.4Zm-52.15-67.95c8.91,6.51,24.73,20.19,32.55,27.98,11.97-9.84,16.04-18.12,17.41-22.22-2.83-1.65-28.85-26.19-32.2-24.77-2.63-1.19-16.13,17.76-17.77,19.01Zm-59.3-46.8l36.73,28.99,14.6-17.55-.09-.07c3.17-3.47,7.83-7.9,3.1-12.12,0,0-27.7-23.07-27.7-23.07-6.54-7.67-22.79,21.86-26.65,23.82Zm-59.71-47.13l37.15,29.32,19.59-23.53-.18-.15c3.24-3.92,10.36-9.05,4.89-14.04-5-1.57-29.5-31.33-35.44-22.37l-.23-.19-25.77,30.97Zm-59.49-46.96l36.93,29.15c29.67-41.15,45.48-28.26-.49-64.36-7.1-8.24-31.98,32.95-36.44,35.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m178.69,965.13c-27.33-4.36-108.35,16.75-107.44-31.17,0,0,0-343,0-343,0-17.19,13.98-31.17,31.16-31.17h151.88c19.31-.49,35.12,19.11,30.43,37.89,0,0-75.59,342.98-75.59,342.98-3.18,14.4-15.69,24.47-30.44,24.47Zm-76.29-376.6c-4.84,2.1-4.52,345.65-.01,347.86.01,0,76.3,0,76.3,0,5.56,1.06,75.56-343.14,77.97-344.91,1.4-8.24-151.66-.25-154.26-2.95Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m987.84,965.13c-25.44-4.33-100.77,15.04-106.73-24.46,0,0-75.6-343-75.6-343-4.67-18.73,11.12-38.39,30.44-37.87,0,0,151.88,0,151.88,0,17.18,0,31.16,13.98,31.16,31.17v343c0,17.19-13.98,31.17-31.16,31.17Zm-153.79-375.69c.33,3.93,72.11,345.42,77.49,346.95,0,0,76.3,0,76.3,0,4.84-1.99,4.52-345.72.01-347.86-1.91.88-152.6-1.71-153.8.91Z"
  })), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 669.92,
    y: 719.86,
    width: 28.74,
    height: 237.52,
    transform: "translate(-395.67 766.41) rotate(-46.96)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 622.88,
    y: 801.96,
    width: 28.74,
    height: 204.84,
    transform: "translate(-459.67 760.29) rotate(-47.35)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 574.42,
    y: 878.86,
    width: 28.73,
    height: 176.25,
    transform: "translate(-522.12 748.74) rotate(-47.55)"
  }))), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "881.16 262.9 668.09 262.9 668.09 38.51 696.82 38.51 696.82 234.17 881.16 234.17 881.16 262.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPas8Icon);
export default __webpack_public_path__ + "static/media/pas8Icon.d0b4cc1346cdce88710c88d8d94a0ef6.svg";
export { ForwardRef as ReactComponent };